<template>
  <div>
    <v-stepper-step :complete="step > stepConfig" step="!">
      Dados Médicos
      <template v-if="step > stepConfig">
        <v-chip small class="mt-1 mb-1"
          >Médico: {{ atestadoEnviar.nomeMedico }}</v-chip
        >
        <v-chip small>CRM/CRO: {{ atestadoEnviar.crmcro }}</v-chip>
      </template>
    </v-stepper-step>
    <v-stepper-content :step="stepConfig">
      <v-card flat>
        <v-card-text class="pt-0 pb-0">
          <v-row>
            <v-col xl="3" md="3" lg="3" sm="12" cols="12">
              <v-text-field
                label="Buscar pelo código"
                placeholder="Código"
                v-model="atestadoEnviar.codMedico"
                v-mask="'######'"
              ></v-text-field>
            </v-col>
            <v-col
              align-self="center"
              xl="auto"
              lg="auto"
              md="auto"
              sm="12"
              cols="12"
            >
              <v-btn
                :block="$mq === 'sm'"
                small
                rounded
                color="secondary"
                class="white--text"
                @click="buscarDadosMedico()"
                :loading="buscando"
                >Buscar</v-btn
              >
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col cols="12">
              <v-text-field
                label="Nome do Médico"
                v-model="atestadoEnviar.nomeMedico"
              ></v-text-field>
              <v-text-field
                label="CRM/CRO do Médico"
                v-model="atestadoEnviar.crmcro"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn small rounded color="info" @click="continuar()"
                >Continuar</v-btn
              >
              <botao-anterior />
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-stepper-content>
  </div>
</template>

<script>
import axios from "axios";
//import BotoesStepper from "./BotoesStepper.vue";
import { mapMutations, mapState } from "vuex";
import BotaoAnterior from "./BotaoAnterior.vue";
export default {
  components: { BotaoAnterior },
  computed: mapState("atestado", ["atestadoEnviar", "step", "atestSelec"]),
  data: () => ({
    buscando: false,
    stepConfig: 60,
  }),
  methods: {
    ...mapMutations("atestado", ["setNextStep"]),
    async buscarDadosMedico() {
      this.buscando = true;
      await axios
        .get(
          `/colaborador/atestados?funcao=MEDICO&codigo=${this.atestadoEnviar.codMedico}`
        )
        .then((res) => {
          if (res.data.success) {
            this.atestadoEnviar.nomeMedico = res.data.data.nome;
            this.atestadoEnviar.crmcro = res.data.data.crmcro;
            //this.atestadoEnviar.codMedico = this.codigoMedico;
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));
      this.buscando = false;
    },
    continuar() {
      if (this.atestadoEnviar.nomeMedico == "") {
        this.$toasted.error("Informe o nome do médico");
        return;
      }

      if (this.atestadoEnviar.crmcro == "") {
        this.$toasted.error("Informe o CRM/CRO do médico");
        return;
      }

      this.setNextStep();
    },
  },
  mounted() {
    if (!this.atestSelec) {
      this.atestadoEnviar.codigoMedico = "";
      this.atestadoEnviar.nomeMedico = "";
      this.atestadoEnviar.crmcro = "";
    }
  },
};
</script>

<style>
</style>